import { ORGANIZATION_ID, SITE_URL } from "../structured-data-core";
import {
  MAIN_MARKETS,
  SERVICE_AREAS,
  VIRTUAL_CONSULT_PATH,
  type ServiceAreaKey,
} from "../service-areas";

/**
 * JSON-LD for the city page of an out-of-market office (service-areas.ts).
 * The page describes a service that RESTORE Hair (the root Organization
 * node) offers to this city through virtual consultations and its five main
 * locations. It is not a clinic at the office address, so there is no
 * MedicalBusiness / LocalBusiness node, no address and no phone.
 */
export function serviceAreaSchema(key: ServiceAreaKey, pageUrl: string, description: string) {
  const a = SERVICE_AREAS[key];
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${pageUrl}#service`,
    name: `RESTORE Hair transplant consultations serving ${a.name}, ${a.stateName}`,
    serviceType: "Hair transplant consultation",
    description,
    url: pageUrl,
    provider: { "@id": ORGANIZATION_ID },
    areaServed: {
      "@type": "City",
      name: a.name,
      containedInPlace: {
        "@type": a.region === "DC" ? "AdministrativeArea" : "State",
        name: a.region === "DC" ? "District of Columbia" : a.stateName,
      },
    },
    availableChannel: {
      "@type": "ServiceChannel",
      name: "Virtual consultation",
      serviceUrl: `${SITE_URL}${VIRTUAL_CONSULT_PATH}`,
    },
    disambiguatingDescription: `Served by the RESTORE Hair main locations: ${MAIN_MARKETS.join(", ")}.`,
  };
}
